import { render, staticRenderFns } from "./EntMemberClass.vue?vue&type=template&id=1dc95635"
import script from "./EntMemberClass.vue?vue&type=script&lang=js"
export * from "./EntMemberClass.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports